export default __webpack_public_path__ + "static/media/chrome.fc0c6180.png";